<template>
  <v-card class="pl-2 pr-2 pb-0 mb-2" outlined tile>
    <b-form
      inline
      v-on:submit.prevent="onSubmit"
      method="POST"
      accept-charset="UTF-8"
      enctype="multipart/form-data"
      id="analyticsForm"
    >
      <v-row>
        <v-col cols="12" sm="2">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateText"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                label="From"
                required
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" no-title scrollable>
              <v-btn text color="primary" @click="menu = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(date)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="2">
          <v-select
            v-model="selectedPeriod"
            :items="periods"
            label="Period"
            required
          >
          </v-select>
        </v-col>
        <v-col cols="12" sm="2">
          <v-select
            v-model="selectedMetric"
            :items="metrics"
            label="Metric"
            required
          >
          </v-select>
        </v-col>
        <v-col cols="12" sm="2" class="pt-6">
          <v-btn type="submit" depressed tile>
            <v-icon left> mdi-magnify </v-icon> Search
          </v-btn>
        </v-col>
      </v-row>
    </b-form>
  </v-card>
</template>


<script>
import moment from "moment";
// import { getLocations } from "@/api/locations";

export default {
  name: "kpi-summary-search",
  
  data() {
    return {
      date: moment().format("YYYY-MM-DD"),
      menu: false,
      modal: false,
      periods: ['month', 'week'],
      selectedPeriod: 'month',
      metrics: ['sales', 'traffic'],
      selectedMetric: 'sales',
    };
  },

  computed: {
    dateText() {
      if (this.date) {
        return this.date;
      }
      return "";
    },
  },
  methods: {
    getIndex(obj) {
      return Math.floor(Math.random() * obj.length);
    },
    onSubmit() {
      console.log("Submit")
    },
  },
};
</script>